<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="workshops"
      :table-select="false"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="车间编号">
            <el-input v-model.trim="filter.workshopNo" placeholder="请输入车间编号" clearable />
          </el-form-item>
          <el-form-item label="车间名称">
            <el-input v-model.trim="filter.workshopName" placeholder="请输入车间名称" clearable />
          </el-form-item>
          <el-form-item label="所属工厂">
            <el-input v-model.trim="filter.factoryName" placeholder="请输入工厂名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <WorkShopEdit ref="workShopEdit" @save-success="loadData"></WorkShopEdit>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import WorkShopEdit from "./WorkShopEdit";
export default {
  components: { viewTable, WorkShopEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(672),
        editAuth: this.$auth(673),
        delAuth: this.$auth(674),
      },
      filter: {
        workshopNo: "",
        workshopName: "",
        factoryName: "",
      },
      columnsProperty: [
        {
          tooltip: true,
          key: "workshopNo",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "workshopName",
          minWidth: 150,
        },
        {
          tooltip: true,
          key: "factoryName",
          minWidth: 150,
        },
        {
          tooltip: true,
          key: "creatorName",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "createTime",
          width: 160,
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 140,
          slot: "action",
        },
      ],
    };
  },
  methods: {
    // 查询车间列表
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 新建 编辑
    addEditHandle(row) {
      this.$refs.workShopEdit.open(row);
    },

    // 删除
    deleteHandle(row) {
      this.$http.delete("basic", "workshops", row.pkid).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
